import React from 'react'

import {Button} from '../../../../shared/Button'
import {QuestionLabel, QuestionRow, ToggleGroup} from './ToggleField.style'

export function ToggleField({field, value, onChange, disabled, error}) {
  return (
    <QuestionRow>
      <QuestionLabel>{field.label}</QuestionLabel>
      <ToggleGroup disabled={disabled}>
        {field.options.map(option => (
          <Button
            key={option.value}
            size="sm"
            variant={
              value === option.value
                ? 'secondary-toggle-active'
                : 'secondary-toggle-inactive'
            }
            disabled={disabled}
            onClick={() => onChange(field.key, option.value)}
          >
            {/* <ToggleButton
            key={option.value}
            type="button"
            isActive={value === option.value}
            disabled={disabled}
            onClick={() => onChange(field.key, option.value)}
          > */}
            {option.label}
          </Button>
        ))}
      </ToggleGroup>
      {error && (
        <span style={{fontSize: '12px', color: '#e53e3e'}}>{error}</span>
      )}
    </QuestionRow>
  )
}
